import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingPigletManureAdditive, getFootprintingPigletManureAdditiveAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_PIGLET_MANURE_ADDITIVE } from "consts";

export const useGetFootprintingPigletManureAdditive = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_PIGLET_MANURE_ADDITIVE, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingPigletManureAdditiveAdmin(primaryDataId ?? "") : getFootprintingPigletManureAdditive(primaryDataId ?? "")),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
